import { useEffect, useRef, useState } from "react";
import { IDocumentMastDropdown } from "../../../models/IDropdown";
import { Fetch, baseUrl } from "../../../shared/Fetch";
import { JVDropdown } from "../../../shared/JVDropdown";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { IPurchaseOrder, POStatus } from "../../../models/PurchaseOrder";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { PODocType } from "../../../models/FDropdown";
import { JVDate } from "../../../shared/JVDate";
import { FileUpload, FileUploadHandlerParam } from "primereact/fileupload";
import { format } from "date-fns";
import { Toast } from "primereact/toast";
import { ILogin } from "../../../models/Login";

interface IPaperWork {
    document_Type?: string,
    document_ID?: number,
    pO_ID?: number,
    consultant_ID?: number,//Consultant
    sub_Vendor_ID?: number,//Vendor
    prime_Vendor_ID?: number,//Client
    document_Name?: string,
    expiration_Date?: Date,
    document_Path?: string,
    addedBy?: number,
    addedByName?: string,
    editedBy?: number,
    editedByName?: string,
    document_Status?: string,
    addedOn?: Date
}
interface Iprops {
    po: IPurchaseOrder
    open: boolean,
    hideDialog: () => void,
    toast: any,
    bySubvendor?: boolean,
    isConsultant?: boolean
}

const schema = yup.object({
    document_Type: yup.string().required("Select Document Type"),
    document_Name: yup.string().required("Select Document Name").min(1, "Select Document Name"),
    expiration_Date: yup.date().required("Expiration Date is required").typeError("Expiration Date is required"),
});

export const APW = (props: Iprops) => {
    const [loading, setLoading] = useState(false);
    const [documents, setDocuments] = useState<Array<IDocumentMastDropdown>>();
    const [documentsList, setDocumentsList] = useState<{
        consultant_documents: Array<IPaperWork>,
        vendor_documents: Array<IPaperWork>,
    }>({ consultant_documents: [], vendor_documents: [] });
    const [docFile, setDocFile] = useState<File | null | any>(null);

    const toast = useRef<any>(null);

    const [paperWork, setPaperWork] = useState<IPaperWork>({ document_Type: "Consultant" });

    const loginObj: ILogin = JSON.parse(sessionStorage.getItem("auth") + "");

    const { control, handleSubmit, formState: { errors }, reset, setValue, watch } = useForm<IPaperWork>({
        resolver: yupResolver(schema),
        defaultValues: { document_Type: "Consultant" },
        shouldFocusError: false
    });

    const loadDocuments = async (type?: string) => {
        const response = await Fetch("Dropdown/document", "GET", null, null, null);
        if (response) {
            const data: Array<IDocumentMastDropdown> = await response.json();
            const consultant: Array<IDocumentMastDropdown> = [];
            const Vendor: Array<IDocumentMastDropdown> = [];
            const Client: Array<IDocumentMastDropdown> = [];
            data.forEach((d: IDocumentMastDropdown) => {
                if (!(d.document_Name.includes("Vendor") || d.document_Name.includes("Client"))) consultant.push(d);
                if ((d.document_Name.includes("Vendor"))) Vendor.push(d);
                if ((d.document_Name.includes("Client"))) Client.push(d);
            });
            if (type === "Consultant") {
                setDocuments(consultant);
            } else if (type === "Vendor") {
                setDocuments(Vendor);
            } else if (type === "Client") {
                setDocuments(Client);
            } else {
                setDocuments(consultant);
            }

        }
    }

    const loadDocumentsList = async () => {
        setLoading(true);
        const response = await Fetch("vwPODetailsExternalUser/apw", "GET", null, `po_id=${props.po.pO_ID}&companyID=${props.po.company_ID_Sales}`, props.toast);
        if (response) {
            const data: {
                consultant_documents: Array<IPaperWork>,
                vendor_documents: Array<IPaperWork>,
            } = await response.json();
            setDocumentsList(data);
        }
        setLoading(false);
    }

    useEffect(() => { loadDocuments(); }, []);
    useEffect(() => {
        if (props.open && props.po.pO_ID) loadDocumentsList();
        if (props.isConsultant) {
            setValue('document_Type', 'Consultant');
        }
    }, [props.open, props.po.pO_ID]);
    useEffect(() => {
        let expiration_Date;
        if (paperWork.expiration_Date) expiration_Date = new Date(paperWork.expiration_Date);
        reset({ ...paperWork, expiration_Date });
    }, [paperWork]);

    useEffect(() => {
        const subscription = watch((value, { name, type }) => {
            if (name === "document_Type") {
                if (value.document_Type === "Vendor" && value.document_Type != null) {
                    loadDocuments("Vendor");

                } else if (value.document_Type === "Client" && value.document_Type != null) {
                    loadDocuments("Client");

                } else if (value.document_Type === "Consultant" && value.document_Type != null) {
                    loadDocuments("Consultant");
                } else {
                    loadDocuments("Consultant");
                }
            }
        });

        return () => subscription.unsubscribe();
    }, [watch]);

    const saveDocument = async (body: IPaperWork, isDelete?: boolean) => {
        if (docFile === null) {
            toast.current.show({ severity: 'error', detail: "File is required", life: 3000 });
            return;
        }
        
        setLoading(true);
        body.pO_ID = props.po.pO_ID;
        body.consultant_ID = props.po.consultant_ID;
        body.sub_Vendor_ID = props.po.consultant_Employeer_Sub_Vendor;
        body.prime_Vendor_ID = props.po.prime_Vendor;
        const method = body.document_ID ? "PUT" : "POST";
        const message = body.document_ID ? "Updated Successfully" : "Added Successfully";

        const formData = new FormData();
        formData.append("file", docFile);
        formData.append("paperWork", JSON.stringify(body));
        //formData.append('userType', `${loginObj.user_Type}`);
        //formData.append('userID', `${loginObj.user_Type === 2 ? loginObj.consultant_ID : loginObj.sub_Vendor_ID}`);
        const params = {
            method: method,
            headers: { Authorization: `Bearer ${JSON.parse(sessionStorage.getItem("auth") + "")?.token}`, },
            body: formData,
        };
        const response = await fetch(`${baseUrl}vwPODetailsExternalUser/apw?subvendorUser=${loginObj.sub_Vendor_ID || 0}&userType=${loginObj.user_Type}&po_id=${props.po.pO_ID || 0}`, params);

        // const response = await Fetch("vwPODetails/apw", method, body, null, toast);
        if (response.ok) {
            toast.current.show({ severity: 'success', content: `Document ${message}` });
            setPaperWork({ document_Type: "Consultant" });
            setDocFile(null);
            loadDocumentsList();
            reset({ document_Type: "Consultant" });
            loadDocuments();
        } else {
            const errorText = await response.text();
            console.error('Error:', errorText);
            props.toast.current.show({ severity: 'error', detail: errorText, life: 3000 });
            //toast.current.show({ severity: 'error', content: `Document ${message}` });
            setLoading(false);

        }
        setLoading(false);

        // if (isDelete) {
        //     const response = await Fetch("vwPODetails/apw", "DELETE", body, null, props.toast);
        //     if (response) {
        //         props.toast.current.show({ severity: 'success', content: `Document Deleted Successfully` });
        //         setPaperWork({ document_Type: "Consultant" });
        //         loadDocumentsList();
        //     } else setLoading(false);
        // } else {
        //     const method = body.document_ID ? "PUT" : "POST";
        //     const message = body.document_ID ? "Updated Successfully" : "Added Successfully";

        //     const response = await Fetch("vwPODetails/apw", method, body, null, props.toast);
        //     if (response) {
        //         props.toast.current.show({ severity: 'success', content: `Document ${message}` });
        //         setPaperWork({ document_Type: "Consultant" });
        //         loadDocumentsList();
        //     } else setLoading(false);
        // }
    }

    function onSubmit(data: IPaperWork) {
        saveDocument(data);
    }

    const fileUploade = async (event: FileUploadHandlerParam) => {
        if (event.files[0].size > 102400 * 5) {
            toast.current.show({ severity: 'error', content: "Document should be less than 5 MB." });
            event.options.clear();
        } else {
            setDocFile(event.files[0]);
            toast.current.show({ severity: 'success', content: "Document Selected." });
            event.options.clear();
        }
    }

    // const uploadeFile = async (file: File) => {
    //     setLoading(true);
    //     let formData = new FormData();
    //     formData.append("file", file);

    //     const params = {
    //         method: "POST",
    //         headers: {
    //             'Authorization': `Bearer ${JSON.parse(sessionStorage.getItem('auth') + "")?.token}`
    //         },
    //         body: formData
    //     };
    //     const response = await fetch(`${baseUrl}Ticket/file`, params);
    //     if (response) {
    //         const data = await response.text();
    //         setValue("document_Path", data);
    //         props.toast.current.show({ severity: 'success', content: `Document Uploaded Successfully as -"${data}"` });
    //     }
    //     setLoading(false);

    //     return response ? true : false;
    // }

    const downloadDocument = async (data: IPaperWork) => {
        data.pO_ID = props.po.pO_ID;
        data.consultant_ID = props.po.consultant_ID;
        data.sub_Vendor_ID = props.po.sub_Vendor_ID;
        data.prime_Vendor_ID = props.po.prime_Vendor;
        const params = {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${JSON.parse(sessionStorage.getItem('auth') + "")?.token}`
            },
            body: JSON.stringify(data)
        };
        try {
            const response = await fetch(`${baseUrl}${"vwPODetailsExternalUser/document"}`, params);
            if (response.status === 200) {
                const blob = await response.blob();
                const href = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.download = data.document_Path ? data.document_Path : "document";
                a.href = href;
                a.click();
                a.href = '';
            } else if (response.status === 400) {
                const message = await response.text();
                props.toast.current.show({ severity: 'error', detail: message, life: 3000 });
            }
        } catch {
            props.toast.current.show({ severity: 'error', detail: 'Something went Wrong', life: 3000 });
        }
    }

    function onHide() {
        props.hideDialog();
        setDocumentsList({ consultant_documents: [], vendor_documents: [] });
        setPaperWork({ document_Type: "Consultant" });
    }

    const expiration_Date = (rowData: IPaperWork) => {
        let date;
        if (rowData.expiration_Date) date = format(new Date(rowData.expiration_Date), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };

    const viewDocument = async (data: IPaperWork) => {
        data.pO_ID = props.po.pO_ID;
        data.consultant_ID = props.po.consultant_ID;
        //data.sub_Vendor_ID = props.po.consultant_Employeer_Sub_Vendor;
        data.prime_Vendor_ID = props.po.prime_Vendor;

        let viewQuery = "";

        if (data.document_Type === "Consultant") {
            viewQuery = `consultantID=${data.consultant_ID}`;
        } else if (data.document_Type === "Vendor") {
            viewQuery = `subvendorID=${loginObj.sub_Vendor_ID}`;
        };

        const params = {
            method: "GET",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${JSON.parse(sessionStorage.getItem('auth') + "")?.token}`
            },
        };
        try {
            const response = await fetch(`${baseUrl}${"vwPODetailsExternalUser/viewDocument"}?${viewQuery}&path=${data.document_Path}`, params);
            if (response.status === 200) {
                const blob = await response.blob();
                const href = window.URL.createObjectURL(blob);
                window.open(href, '_blank');
                setTimeout(() => {
                    window.URL.revokeObjectURL(href);
                }, 100);
            } else if (response.status === 400) {
                const message = await response.text();
                toast.current.show({ severity: 'error', detail: message, life: 3000 });
            }
        } catch {
            toast.current.show({ severity: 'error', detail: 'Something went Wrong', life: 3000 });
        }
    };

    const file = (rowData: IPaperWork) => {
        return (<>
            {/* <span onClick={() => viewDocument({ ...rowData })} className="cursor-pointer text-cyan-700 underline mr-2">View</span> */}
            <span onClick={() => downloadDocument({ ...rowData })} className="cursor-pointer text-cyan-700 underline">Download</span>
        </>);
    };
    const actionBodyTemplate = (rowData: IPaperWork) => {
        return <div style={{ display: 'flex' }}>
            <Button icon="pi pi-pencil" label="Update" className="p-button-rounded  p-button-text" onClick={() => {
                loadDocuments(rowData.document_Type);
                setPaperWork({ ...rowData });
            }} />
            {/* <Button icon="pi pi-trash" label="Delete" className="p-button-rounded p-button-text p-button-danger" onClick={() => saveDocument({ ...rowData }, true)} /> */}
        </div>
    };

    return (
        <>
            <Dialog visible={props.open} style={{ width: '80vw' }} header="Add/Edit Consultant/Vendor Document" className="p-fluid" onHide={onHide}>
                {(props?.po?.pO_Status === POStatus.To_Join || props?.po?.pO_Status === POStatus.Joined) && <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid mt-3">
                    {!props.isConsultant && <JVDropdown required column={2} disabled={paperWork.document_ID !== undefined && paperWork.document_ID !== 0} label="Document Type" control={control} name="document_Type" error={errors.document_Type?.message} options={!props.isConsultant ? PODocType : PODocType.filter(e => e.name === "Consultant")} optionLabel="name" optionValue="name" placeholder="Select Document Type" />}
                    <JVDropdown required column={2} disabled={paperWork.document_ID !== undefined && paperWork.document_ID !== 0} label="Document Name" control={control} name="document_Name" error={errors.document_Name?.message} options={documents} optionLabel="document_Name" optionValue="document_Name" placeholder="Select Document Name" />
                    <JVDate column={2} label="Expiration Date" required control={control} name="expiration_Date" error={errors.expiration_Date?.message} />
                    <div className="field col-12 md:col-3">
                        <label htmlFor="file">Document<span style={{ color: 'red' }}>*</span></label>
                        <FileUpload chooseLabel="Choose Document" mode="basic" name="file" accept="*" customUpload auto uploadHandler={fileUploade} />
                    </div>
                    <div className="field col-12 md:col-3">
                        <label htmlFor="">&nbsp;</label>
                        <Button loading={loading} label="SUBMIT" type="submit"></Button>
                    </div>
                </form>}
                <DataTable className="mt-2" style={{ border: '1px solid rgba(105,105,105,0.5)', borderTopWidth: "0" }}
                    size="small" value={documentsList.consultant_documents} header="Consultant Document List" showGridlines stripedRows loading={loading}
                >
                    <Column field="document_Name" header="Document Name" />
                    <Column field="expiration_Date" header="Expiration Date" body={expiration_Date} />
                    <Column field="file" header="File" body={file} />
                    <Column field="addedByName" header="Added By" />
                    <Column field="editedByName" header="Edited By" />
                    {/* <Column field="document_Status" header="Status" /> */}
                    {props?.po?.pO_Status === POStatus.Joined && <Column body={actionBodyTemplate} header="Action" headerStyle={{ width: '5%' }} />}
                </DataTable>
                {!props.isConsultant && <DataTable className="mt-2" style={{ border: '1px solid rgba(105,105,105,0.5)', borderTopWidth: "0" }}
                    size="small" value={documentsList.vendor_documents} header="Vendor Document List" showGridlines stripedRows loading={loading}
                >
                    <Column field="document_Name" header="Document Name" />
                    <Column field="expiration_Date" header="Expiration Date" body={expiration_Date} />
                    <Column field="file" header="File" body={file} />
                    <Column field="addedByName" header="Added By" />
                    <Column field="editedByName" header="Edited By" />
                    {/* <Column field="document_Status" header="Status" /> */}
                    {props?.po?.pO_Status === POStatus.Joined && <Column body={actionBodyTemplate} header="Action" headerStyle={{ width: '5%' }} />}
                </DataTable>}
                <Toast ref={toast} />
            </Dialog>
        </>
    );
}